import { Chip, SxProps } from "@mui/material";
import { observer } from "mobx-react";

export interface VersionChipProps {
  label: string;
  onClick?: () => void;
  sx?: SxProps;
}

const VersionChip = observer((props: VersionChipProps) => {
  if (!props.label) {
    return null;
  }

  return (
    <Chip
      label={props.label}
      sx={{
        height: "24px",
        justifyContent: "center",
        fontSize: "0.75rem",
        border: "1px solid",
        color: "primary.dark",
        borderColor: (theme) => theme.palette.custom?.borderColor,
        ...props.sx,
      }}
      onClick={props.onClick}
    />
  );
});

export default VersionChip;
